var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.hasQuoteContent)?_c('div',{class:{
    'reference-content': true,
    'reverse': _vm.message.flow === 'out',
  },on:{"click":_setup.scrollToOriginalMessage}},[(_setup.isMessageRevoked)?_c('div',{staticClass:"revoked-text"},[_vm._v(" "+_vm._s(_setup.TUITranslateService.t('TUIChat.引用内容已撤回'))+" ")]):_c('div',{staticClass:"max-double-line"},[_vm._v(" "+_vm._s(_setup.messageQuoteContent.messageSender)+": "+_vm._s(_setup.transformTextWithKeysToEmojiNames(_setup.messageQuoteText))+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }